import { render, staticRenderFns } from "./GridMatchesListPage.vue?vue&type=template&id=64c5deb8&scoped=true&"
import script from "./GridMatchesListPage.vue?vue&type=script&lang=js&"
export * from "./GridMatchesListPage.vue?vue&type=script&lang=js&"
import style0 from "./GridMatchesListPage.vue?vue&type=style&index=0&id=64c5deb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5deb8",
  null
  
)

export default component.exports